<template>
    <div>
        <Modal @onConfirm="onConfirm" @onClose="onClose" :isOpen="isOpen" :modalTitle="currentPosition.name" class="add_evals_modal">

            <AddContacts @contactListModified="handleContactList" ref="addContactComponent2" contactLabel="candidat" :allowFileUpload="true">
                <template slot="headSlot">
                    <notifText>
                        <span v-html="$t('modules.positions.index.addEvalModal.notice')"></span>
                    </notifText>
                </template>
            </AddContacts>

        </Modal>
    </div>
</template>

<script>
import AddContacts from '@/components/shared/addContacts/addContacts'

export default {
    name: 'AddEvalsModal',
    props: ['opened'],
    components: {
        AddContacts
    },
    data(){
        return {
            isOpen: false,
            contactList: [],
            isLoading: false,
            selectedPosition: null
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        }
    },
    methods: {
        handleContactList(contactList){
            this.contactList = contactList
            const evalItemsList = []
            contactList.forEach((evaluation) => {
                evalItemsList.push({ 
                    candidate_first_name: evaluation.first_name, 
                    candidate_last_name: evaluation.last_name, 
                    candidate_email: evaluation.email,
                    docs_ids: evaluation.docs_ids
                })
            })
            this.$store.commit('PositionStore/setEvalList', evalItemsList)
        },
        onConfirm(){
            this.isOpen = false
            this.$emit('closeAddEvals')
            this.$store.dispatch('PositionStore/updatePosition').then( () => {
                this.$emit('addEvalSuccess')
                this.$store.dispatch('PositionStore/indexPositions')
            })
        },
        onClose(){
            this.isOpen = false
            this.$emit('closeAddEvals')
        },
    },
    watch: {
        'opened': {
            handler: function(newVal, oldVal){
                this.isOpen = newVal
            }
        }
    }
}
</script>

<style lang="scss" >

.add_evals_modal{
    text-align: left;
    .modal-card{
        width: 100%;
        max-width: 1024px;

    }
}

</style>